export default __webpack_public_path__ + "static/media/customer4.ae513197.png";